import React, {useEffect} from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import pluginConfig from '../../configuration/cookies/CookiesConsentConfig';
import {Language} from '../../store/slices/languageSlice';
import CookieIcon from '@mui/icons-material/Cookie';
import {IconButton, Tooltip} from '@mui/material';

interface Props {
  language: Language;
  isDarkMode: boolean;
}

const CookieConsentComponent = ({language, isDarkMode}: Props) => {
  useEffect(() => {
    // Nur beim ersten Mount
    CookieConsent.run(pluginConfig);
  }, []);

  useEffect(() => {
    CookieConsent.setLanguage(language);
  }, [language]);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('cc--darkmode');
    } else {
      document.documentElement.classList.remove('cc--darkmode');
    }
  }, [isDarkMode]);

  return (
      <Tooltip title={'Cookie-Einstellungen'} placement="top">
        <IconButton className="cursor-pointer hover:underline text-gray-500 dark:text-neutral-500 font-medium bg-transparent border-none p-0 normal-case"
                    onClick={() => CookieConsent.showPreferences()}>
          <CookieIcon fontSize="small"/>
        </IconButton>
      </Tooltip>
  );
};

export default CookieConsentComponent;